import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon37: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        fillRule="evenodd"
        d="M16.97 0A3.027 3.027 0 0 1 20 3.03v2.94A3.027 3.027 0 0 1 17 9v2.5a.5.5 0 0 1-.854.354L14 9.708v2.262a3.027 3.027 0 0 1-2.852 3.025L10.97 15H6.707l-2.853 2.854A.5.5 0 0 1 3 17.5V15a3.027 3.027 0 0 1-3-3.03V9.03A3.027 3.027 0 0 1 3.03 6L6 5.999V3.03A3.027 3.027 0 0 1 9.03 0h7.94ZM3.03 7C1.906 7 1 7.906 1 9.03v2.94C1 13.094 1.906 14 3.03 14h.47a.5.5 0 0 1 .5.5v1.793l2.146-2.147A.504.504 0 0 1 6.5 14h4.47c1.124 0 2.03-.906 2.03-2.03V9.058c0-.017 0-.036-.002-.057L9.03 9a3.013 3.013 0 0 1-2.849-2H3.03Zm7.47 4a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-6 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm3 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm9.47-10H9.03C7.906 1 7 1.906 7 3.03v2.94c0 .143.016.285.049.428A2.012 2.012 0 0 0 9.03 8h4.47c.133 0 .26.053.354.146L16 10.293V8.5a.5.5 0 0 1 .5-.5h.47C18.094 8 19 7.094 19 5.97V3.03C19 1.906 18.094 1 16.97 1Zm-.47 4a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-6 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm3 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
